import React, {Component} from 'react';
import {SVGIcon} from '@homeaway/react-svg';
import {ALERT__24} from '@homeaway/svg-defs/lib/defs/ALERT__24';
import {SUCCESS__24} from '@homeaway/svg-defs/lib/defs/SUCCESS__24';
import PropTypes from 'prop-types';

import './CancelTripModalRefundRequestCancellation.less';

export default class CancelTripModalRefundRequestCancellation extends Component {
    static propTypes = {
        failedMessage: PropTypes.string,
        requestCancellationMessage: PropTypes.string,
        title: PropTypes.string,
    };

    static defaultProps = {
        failedMessage: '',
        requestCancellationMessage: '',
        title: '',
    };

    render() {
        const {failedMessage, requestCancellationMessage, title} = this.props;

        return (
            <div className="CancelTrip__step">
                <h2 className="CancelTrip__title">{title}</h2>
                <div className="CancelTripModalRefundRequestCancellation__text">
                    <SVGIcon
                        className="text-danger CancelTripModalRefundRequestCancellation__icon"
                        markup={ALERT__24}
                    />
                    <p>{failedMessage}</p>
                </div>
                <div className="CancelTripModalRefundRequestCancellation__text">
                    <SVGIcon
                        className="CancelTripModalRefundRequestCancellation__icon"
                        markup={SUCCESS__24}
                    />
                    <p>{requestCancellationMessage}</p>
                </div>
            </div>
        );
    }
}
